import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CommonProfilePhoneChangeService,
  PhoneFormatModel,
  ChangePhoneRequest,
  AnyValueModelLong
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class CommonProfilePhoneChangeApiService {
  constructor(private apiService: CommonProfilePhoneChangeService) {}

  public changePhone(body: ChangePhoneRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PhoneFormatModel> {
    return this.apiService.changePhone(body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public changePhoneRequest(value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelLong> {
    return this.apiService.changePhoneRequest({ value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
